export const openFileToolMessage = (toolMessage: any, results: any) => {
    let contextText = `<No file contents found>`;
    let truncatedContextText = `<No file contents found>`;

    if (results.errorMessage) {
        contextText = results.errorMessage;
        truncatedContextText = results.errorMessage;
    } else if (results.fileContents) {
        contextText = `File contents:\n${results.fileContents}`;
        truncatedContextText = `File contents:\n<Truncated for brevity>`;
    }

    const content = [{
        type: 'text',
        text: contextText
    }];
    const truncatedContent = [{
        type: 'text',
        text: truncatedContextText
    }];
    return {...toolMessage, content: content, truncatedContent: truncatedContent};
};

export const grepToolMessage = (toolMessage: any, results: any) => {
    let contextText = '<No matches found>';
    let truncatedContextText = '<No matches found>';

    if (results.matches) {
        if (results.matches.length !== 0) {
            contextText = `Found ${results.matches.length} matches:\n\n${results.matches.join('\n')}`;
            truncatedContextText = `Found ${results.matches.length} matches:\n<Truncated for brevity>`;
        }
    }

    const content = [{
        type: 'text',
        text: contextText
    }];
    const truncatedContent = [{
        type: 'text',
        text: truncatedContextText
    }];
    return {...toolMessage, content: content, truncatedContent: truncatedContent};
};
